module.exports = "<button *ngIf=\"params && params.data && params.data.campaignVoucherStatusName\" class=\"{{getClass()}}\">{{getValue()}}</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/ag-grid-custom-components/state-popover/popover.component.html
// module id = ./src/app/shared/ag-grid-custom-components/state-popover/popover.component.html
// module chunks = main